import React from "react";

// Checkbox propio (no accent-color nativo): así el tick queda blanco de forma
// garantizada sobre el fondo #01BEDE en cualquier navegador — accent-color deja
// el color del check a criterio del user-agent y no es controlable por CSS.
export default function SolidarioCheckbox({ checked, indeterminate, onChange, onClick }) {
  return (
    <label
      className="relative inline-flex items-center justify-center h-4 w-4 cursor-pointer shrink-0"
      onClick={onClick}
    >
      <input
        type="checkbox"
        checked={checked}
        ref={(el) => { if (el) el.indeterminate = !!indeterminate; }}
        onChange={onChange}
        className="peer appearance-none h-4 w-4 rounded border border-gray-300 bg-white checked:bg-[#01BEDE] checked:border-[#01BEDE] indeterminate:bg-[#01BEDE] indeterminate:border-[#01BEDE] transition-colors cursor-pointer"
      />
      <svg
        className="absolute h-3 w-3 text-white opacity-0 peer-checked:opacity-100 pointer-events-none"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
      {indeterminate && !checked && (
        <svg
          className="absolute h-3 w-3 text-white pointer-events-none"
          viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
        </svg>
      )}
    </label>
  );
}
